import { useState } from 'react';
import './CustomInput.scss';

function CustomInput({ label, placeholder, idText, onChange, onFocus, onBlur, onFunc }) {
    const [inputValue, setInputValue] = useState("");

    const onInputChange = (event) => {
        setInputValue(event.target.value)
        onChange(event.target.value)
    }

    const onKeyDown = (event) => {
        if (event.key === "Enter") {
            if (idText === "inputLogin") {
                document.getElementById("inputPassword").focus();
            } else {
                document.getElementById("inputPassword").blur();
                onFunc();
            }
        }
    }

    return (
        <div className='input-wrapper'>
            <div className='input-label'>{label}</div>
            <input 
                className='input-block'
                type='text'
                autoComplete='off'
                id={idText}
                value={inputValue}
                onChange={onInputChange}
                placeholder={placeholder}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
            />
        </div>
    )
}

export default CustomInput;